/**
 * GMCC Specials → Program maps（/app/programengine）。
 * STATSIG.PROGRAM_MAPS.SEARCH → PROGRAM_MAPS_SEARCH
 *
 * 打开页只是空表单，不算 VIEW。
 * 点 Fast / Advanced / Market / Massive / GPS 出结果才打 SEARCH。
 * 下载 flyer 打 DOWNLOAD；邮件发出获客打 LEAD。
 * 已不算：切 mode 没点 Search、填表、导出 listings。
 * Flyers hub、Celebrity、落地页 flyer 不跨模块。
 */
export enum GmccProgramMapsEvent {
    /**
     * 询价 / 资格检查出结果。
     * 属性 type=fast|advanced|market|massive|gps
     */
    SEARCH = 'PROGRAM_MAPS_SEARCH',
    /**
     * 下载 flyer。
     * 属性 type 为 flyer 程序名
     */
    DOWNLOAD = 'PROGRAM_MAPS_DOWNLOAD',
    /**
     * 邮件发出 flyer，记一笔获客。
     * 属性 type 为 flyer 程序名
     */
    LEAD = 'PROGRAM_MAPS_LEAD',
}
